import BsMenu from "./BsMenu";

export default Vue => {
    Vue.component(BsMenu.name, BsMenu);
};
